<template>
	<div>
		<v-checkbox
			class="check-base"
			v-bind="$attrs"
			:value="value"
			@change="sendValue"
		></v-checkbox>
	</div>
</template>
<script>

function sendValue(val) {
	this.$emit('change', val);
}

export default {
	name: 'base-checkbox',
	inheritAttrs: false,
	methods: {
		sendValue,
	},
	model: {
		event: 'change',
		prop: 'value',
	},
	props: {
		value: null,
	},
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/base-checkbox.vue